module.exports = __webpack_public_path__ + "img/footer-icon-row-light-infiniti.572acdb7.png";